export const en = {
    'new-banner': 'New ad'
};
